import { render, staticRenderFns } from "./giveProxy.vue?vue&type=template&id=84a5103e&"
import script from "./giveProxy.vue?vue&type=script&lang=js&"
export * from "./giveProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports